import parts from '../data/name-parts.json'
import { hexToRgb } from './color'
import { colors } from './colors'

/**
 * The "RANDOMIZE!" name generator from the register form: finds the named
 * color nearest the hex, plays with its ending, and puts an adjective in
 * front. "#1e90ff" might become "Cheerful Dodger Bluish".
 */

const RESERVED = colors.filter((c) => c.type === 'reserved')

/** The reserved (CSS) color nearest the hex, by RGB distance: "Dodger Blue". */
export function nearestReservedName(hex: string): string {
  const [r, g, b] = hexToRgb(hex)
  let best = RESERVED[0]
  let bestD = Infinity
  for (const c of RESERVED) {
    const [cr, cg, cb] = hexToRgb(c.hex)
    const d = (r - cr) ** 2 + (g - cg) ** 2 + (b - cb) ** 2
    if (d < bestD) {
      bestD = d
      best = c
    }
  }
  return best.name
}

export function capitalizeWords(s: string): string {
  return s.replace(/(^|\s)\S/g, (m) => m.toUpperCase())
}

/** A random, valid color name for the hex. `rand` is injectable for tests. */
export function randomColorName(hex: string, rand: () => number = Math.random): string {
  const pick = <T>(list: readonly T[]): T => list[Math.min(list.length - 1, Math.floor(rand() * list.length))]
  const keyword = nearestReservedName(hex).toLowerCase()
  const suffix = pick(parts.suffixes)
  const noun = suffix && /[aeiou]$/.test(keyword) ? keyword.slice(0, -1) + suffix : keyword + suffix
  return capitalizeWords(`${pick(parts.adjectives)} ${noun}`)
}
